type Props = {};

function LogoV2({}: Props) {
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/vealth1st-bd956.appspot.com/o/vealth1st_logo_colored.png?alt=media&token=51d6a38a-34da-4f7d-b489-d612a9f4f4f5"
      alt="logo"
      height="50px"
      width="150px"
    />
  );
}

export default LogoV2;

